import React from 'react';
import styled from 'styled-components';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import {labels} from '../../../util/utils';
import {IconoirBell} from '@ey-xd/motif-icon';
import {MotifIcon} from '@ey-xd/motif-react';

export function NotificationPlaceholder(props) {
	const {notificationMessage, mode} = props;

	return (
		<StyledSectionWrapper className="notification-main-wrap">
			<MotifTooltip
				contentClassName="notification-tooltip-placeholer"
				allowHover={false}
				variant="alt"
				hideCloseButton
				placement="bottom"
				trigger={
					<MotifButton size="medium" variant="ghost" className="motif-button-icon-only NotificationMotifIcon">
						<MotifIcon iconFunction={IconoirBell} title={labels.notifications} className={'placeholder-header'} />
					</MotifButton>
				}
			>
				{notificationMessage}
			</MotifTooltip>
		</StyledSectionWrapper>
	);
}

const StyledSectionWrapper = styled.section`
	display: flex;
	align-items: center;
	.notification-main-wrap {
		width: 82%;
		display: flex;
		flex-direction: column;
		margin-left: var(--px-5);
		font-size: var(--px-12);
		.motif-button {
			&.motif-button-ghost {
				padding: var(--spacing-x-small) !important;
			}
		}
	}
`;
